<template>
  <div class="pa-character-banner">
    <div class="icon-field">
      <CharacterIcon :character="character" />
    </div>

    <div class="meta-field">
      <ul class="profile-set">
        <li>{{character.name | nameTruncate}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

export default {
  props : {
    character : {
      default: {
        name  : '名前'
      }
    }
  },

  components : {
    CharacterIcon
  },

  // data(){
  //   return {
  //     character : null
  //   };
  // }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-character-banner{
  border-radius: 10px;
  background-color: red;
  background-color: #C8A984;
  color: #604938;
  display: flex;

  .icon-field{
    width:20%;
    padding-top:8px;
    user-select: none;
    text-align: center;

    .pa-character-icon{
      width:55px;
      height:55px;
      line-height: 53px;
      background-color:#C4A27A;
      font-size:32px;

      @media screen and (min-width: $desktop) {
        width:75px;
        height:75px;
        line-height: 73px;
        font-size:38px;
      }
    }
  }

  .meta-field{
    width:80%;

    ul.profile-set{
      padding:.2rem;
      
      li{
      }
    }
  }
}
</style>